import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#fff",
    height: "100vh",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#5675D3",
    },
  },
  divPayung: {
    display: "flex",
    justifyContent: "center",
  },
  payung: {
    height: "15%",
    position: "absolute",
    marginTop: "6%",
    marginLeft: "2%",
  },
  gelombang: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  houseToko: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  content: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      textAlign: "center",
      marginLeft: "60%",
    },
    [theme.breakpoints.down("951")]: {
      marginLeft: 0,
    },
  },
  boxContent: {
    backgroundColor: "#fff",
    marginTop: "1%",
    borderRadius: "5px",

    [theme.breakpoints.up("tablet")]: {
      zIndex: "100",
      backgroundColor: "#fff",
      width: "350px",
      height: "328px",
      marginTop: "8%",
      marginRight: "20%",
      boxShadow: "0px 6px 6px #726e6e73",
    },
    [theme.breakpoints.down("951")]: {
      marginRight: 0,
      justifyContent: "center",
    },
  },
  textContent: {
    fontSize: "30px",
    textAlign: "center",
    marginTop: "10%",
    fontWeight: "bold",

    [theme.breakpoints.up("tablet")]: {
      fontSize: "20px",
      textAlign: "center",
      marginTop: "10%",
      fontWeight: "bold",
    },
  },
  textContent1: {
    fontWeight: "500",
  },
  textContent2: {
    color: "#5675D3",
  },
  textContent3: {
    backgroundColor: "#fff",
    display: "inline-block",
    width: "70%",
    fontSize: 17,

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      display: "inline-block",
      width: "70%",
      fontSize: 12,
    },
  },
  garisContent: {
    height: 1,
    width: "1",
    backgroundColor: "grey",
    marginTop: -40,
    marginLeft: 30,
    marginRight: 30,
    marginBottom: 10,

    [theme.breakpoints.up("tablet")]: {
      height: 1,
      width: "1",
      backgroundColor: "grey",
      marginTop: -30,
      marginLeft: 20,
      marginRight: 20,
    },
  },
  textContent4: {
    marginTop: 30,
  },
  form: {
    marginTop: 50,
    width: "15%",
    marginLeft: 5,

    [theme.breakpoints.up("tablet")]: {
      marginTop: 30,
      width: "14%",
      marginLeft: 5,
    },
  },
  formBottom: {
    marginTop: 10,
    width: "50%",
    height: "25%",

    [theme.breakpoints.up("tablet")]: {
      marginTop: 10,
      width: "50%",
      height: "25%",
    },
  },
  textCopyright: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  textCopyrightH5: {
    color: "#5675D3",
    marginTop: "5%",

    [theme.breakpoints.up("tablet")]: {
      color: "#fff",
      marginTop: 80,
    },
    [theme.breakpoints.down("951")]: {
      marginTop: 40,
    },
  },
  textContent3H4: {
    fontSize: 12,
    color: "#030303",
    fontWeight: "100",

    [theme.breakpoints.up("tablet")]: {
      fontSize: 12,
    },
  },
}));
export default useStyles;
